<div class="extensions-list-container">
  @if ((extensionsList$ | async)?.length) {
    <pdq-input
      class="extensions-search"
      type="text"
      icon="search"
      [withIcon]="true"
      placeholder="Search by name or token"
      [formControl]="searchControl"></pdq-input>
  }
  <pdq-card color="white" variant="popover">
    @if (extensionsListLoading$ | async) {
      <div class="loading-container">
        <pdq-loader></pdq-loader>
      </div>
    } @else {
      @for (ext of filteredExtensionsList$ | async; track ext.id) {
        <div class="components-list">
          <div class="extension-info">
            <div class="extension-title">
              <span class="extension-title__text">
                @for (part of getExtensionDisplayName(ext) | highlightMatch: searchTerm; track $index) {
                  <span [class.extension-title__match]="part.match">{{ part.text }}</span>
                }
              </span>
              @if (isAutonomousDiscount(ext)) {
                <pdq-ai-mark variant="pill"></pdq-ai-mark>
              }
            </div>
            <div class="type" [class.type--as-is]="ext.type === extensionComponentType.ORDER_PROTECTION">
              @for (part of formatLabel(ext.type) | highlightMatch: searchTerm; track $index) {
                <span [class.type__match]="part.match">{{ part.text }}</span>
              }
              @if (ext.testMode) {
                <pdq-tag variant="quaternary" mode="rect">Test mode</pdq-tag>
              }
            </div>
            @if (ext.usageToken) {
              <div class="extension-token">
                <span class="extension-token__value">
                  @for (part of ext.usageToken | highlightMatch: searchTerm; track $index) {
                    <span [class.extension-token__match]="part.match">{{ part.text }}</span>
                  }
                </span>
                <pdq-button
                  class="extension-token__copy"
                  variant="empty"
                  size="xsmall"
                  ariaLabel="Copy token"
                  (onClick)="copyToken(ext)">
                  <span class="extension-token__copy-icon"></span>
                </pdq-button>
              </div>
            }
          </div>
          <div class="extension-actions">
            @if (ext.isDraft) {
              <pdq-tag variant="tertiary" size="small">Draft</pdq-tag>
            }
            @if (ext.notLive) {
              <pdq-tooltip position="top">
                <pdq-tag variant="tertiary" size="small">No impressions</pdq-tag>
                <ng-template #tip>
                  <div class="not-live-tooltip-content">
                    <span>No impressions in {{ notLiveDaysThreshold }} days.</span>
                    <pdq-button
                      variant="light"
                      size="small"
                      [plain]="true"
                      labelColor="var(--secondary-default)"
                      label="Turn off"
                      (onClick)="enabledToggle.toggle()"></pdq-button>
                  </div>
                </ng-template>
              </pdq-tooltip>
            }
            <pdq-slide-toggle
              #enabledToggle
              [defaultValue]="ext.enabled"
              (onToggle)="onEnableExtension(ext, $event)"></pdq-slide-toggle>
            <pdq-button
              pdqPopover
              variant="ghost"
              icon="dots_menu"
              [popoverTemplate]="actions"
              [forcePosition]="'bottom'"
              [closeOnPopoverClick]="true"
              [closeOnClickOutside]="true">
            </pdq-button>
            <ng-template #actions>
              <pdq-popover-container [loading]="false" [actionList]="true">
                <div class="action-list">
                  @for (option of actionOptions; track option.value) {
                    @if (
                      !(
                        ext.type === extensionComponentType.DYNAMIC_EXTENSION &&
                        (option.value === actionEnum.DUPLICATE || option.value === actionEnum.DELETE)
                      ) &&
                      !(ext.type !== extensionComponentType.DYNAMIC_EXTENSION && option.value === actionEnum.ARCHIVE)
                    ) {
                      <pdq-option (onSelect)="onActionOptionSelect(option.value, ext)">
                        {{ option.label }}
                      </pdq-option>
                    }
                  }
                </div></pdq-popover-container
              >
            </ng-template>
          </div>
        </div>
      } @empty {
        @if (searchTerm) {
          <div class="empty-state">No extensions match your search</div>
        }
      }
    }
  </pdq-card>
</div>
